import React, { useContext, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap';



import { SocketContext } from '../../../context/SocketContext';
import { serverApi } from '../../../api';

export const TablaTicketsPendientes = ( { usuario, dataFromTable, ticketActual, isLoading, setIsLoading } ) => {
    const [pendientesLista, setPendientesLista] = useState([]);
    
    const { socket } = useContext( SocketContext );
    
    
    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 100,
        sortBy: 'hora',
        sortDir: 'asc',
    });

    // tabla
    
    const [searchInput, setSearchInput] = useState('');




    useEffect(() => {
        if (!socket) return;

        const cargarPendientes = (pend) => {
            // Este log es la prueba de fuego: si sale, el mensaje llegó del servidor
            console.log("📩 2. ¡Mensajes recibido! en tableTickestPendientes:", pend);
            
            const asignadosStr = localStorage.getItem('tiposAtencion');
            const uidModulo = localStorage.getItem('uidModulo');
            if (asignadosStr) {
                const asignados = asignadosStr.split(",");
                // const filteredArray = pend.filter(item => asignados.indexOf(item.uidTipoAtencion) >= 0);
                const filteredArray = pend.filter(item => {

                    const perteneceTipo =
                        asignados.includes(
                            item.uidTipoAtencion
                        );

                    const perteneceModulo =
                        item.uidModulo === uidModulo;

                    return (
                        perteneceTipo &&
                        perteneceModulo
                    );
                });

                console.log(
                    "🔍 3. Tickets filtrados para mostrar:",
                    filteredArray.length
                );
                
                setPendientesLista(filteredArray);
            } else {
                console.warn("⚠️ No hay 'tiposAtencion' en localStorage, el mensaje llegó pero no se filtró nada.");
            }
        };

        socket.on('tickets-pendientes-lista-consultorios-varios', cargarPendientes);


        return () => {
            console.log("♻️ Limpiando listener 'tickets-pendientes-lista'...");
            socket?.off('tickets-pendientes-lista', cargarPendientes);
        }
    }, [socket]);

     
    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 800); 

        return () => clearTimeout(timeout);

    }, [searchInput]);
        
        
    

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };
   
    useEffect(() => {
            
        async function fetchData() {
 
            try {

                const codigoEntidad = usuario.codigoEntidad;
                const codigoUbicacion = usuario.codigoUbicacion;
                const uidModulo=  usuario.uidModulo;
                const uidUsuario=  usuario.uidUsuario;
                const agente =  usuario.agente;
                
                const resp = await serverApi.get(`/tickets/pendientes-lista-consultorio`, 
                    { 
                        params: {
                            ...query,
                            codigoEntidad,
                            codigoUbicacion,
                            uidModulo,
                            uidUsuario,
                            agente,

                        } 

                    } 
                );

                console.log(resp);
                
                const tickets = resp.data;

                    if (tickets.ok) {
                        
                        const asigndos= localStorage.getItem('tiposAtencion') ? localStorage.getItem('tiposAtencion').split(",") : [];
                        const filteredArray = tickets.pendientes.filter(item => asigndos.indexOf(item.uidTipoAtencion) >= 0);
                        setPendientesLista(filteredArray);
                        
                    } else {
                        console.error("Error al llamar ticket:", tickets.error);
                    }
            
                
            } catch (error) {
                console.error("Error al obtener ubicaciones", error);
            }
                
            
        }

        fetchData();
        
    }, [query, usuario])

    

    const llamarPorTicket = async (ev, uidTicketFlujo) => {
        ev.preventDefault();

        // return console.log("tictketActual", ticketActual, "uidTicket", uidTicket);
        

        
        try {
            const codigoEntidad = usuario.codigoEntidad;
            const codigoUbicacion = usuario.codigoUbicacion;
            const uidModulo=  usuario.uidModulo;
            const uidUsuario=  usuario.uidUsuario;
            const agente =  usuario.agente;
            const ticketAnterior = ticketActual;
            
            setIsLoading(true);
            const resp = await serverApi.post(`/tickets/llamar-por-ticket`, 
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidModulo,
                    uidUsuario,
                    agente,
                    uidTicketFlujo,
                    ticketAnterior,
                } 
            );

            const ticket = resp.data;
            if (ticket.ok) {
                dataFromTable( ticket.ticket )
            } else {
                console.error("Error al llamar ticket:", ticket.error);
            }
          
            
        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setIsLoading(false);
        }
                
    }

    return (
        <div >

            <div className='col-12'>
                <div className=' float-end col-lg-4 col-12'>

                    <input
                        type='text'
                        placeholder='Buscar...'
                        className='form-control'
                        value={searchInput}
                        onChange={(ev) => setSearchInput(ev.target.value)}
                    />

                </div>
            
            </div>

            <div className='col-12 ' style={{ fontSize: '14px', verticalAlign: 'middle' }} >
                <Table responsive="md" striped hover style={{minWidth: 600}} className='max400' >
                    <thead>
                        <tr>
                            <th width={'10%'}>Ticket</th>
                            <th width={'35%'} onClick={ () => handleSort('tipoAtencion') }>
                                <span style={{ color: "gray" }}>
                                    <a href='/#' onClick={ ev => ev.preventDefault() } > Atención </a>
                                    {query.sortBy === 'tipoAtencion' && query.sortDir === 'asc' && '▲'}
                                    {query.sortBy === 'tipoAtencion' && query.sortDir === 'desc' && '▼'}
                                </span> 
                            </th>
                            <th width={'35%'} onClick={ () => handleSort('nombrePaciente') }>
                                <span style={{ color: "gray" }}>
                                    <a href='/#' onClick={ ev => ev.preventDefault() } > Paciente </a>
                                    {query.sortBy === 'nombrePaciente' && query.sortDir === 'asc' && '▲'}
                                    {query.sortBy === 'nombrePaciente' && query.sortDir === 'desc' && '▼'}
                                </span> 
                            </th>
                            <th width={'20%'} onClick={ () => handleSort('hora') }>
                                <a href='/#' onClick={ ev => ev.preventDefault() } > Hora </a>

                                <span style={{ color: "gray" }}>
                                    {query.sortBy === 'hora' && query.sortDir === 'asc' && '▲'}
                                    {query.sortBy === 'hora' && query.sortDir === 'desc' && '▼'}
                                </span> 
                            </th>
                        </tr>

                    </thead>
                    <tbody width={'100%'} style={{ fontSize: '10px', verticalAlign: 'middle' }} >
                        {pendientesLista.map((item, i) => (

                            <tr key={item.uidTicket}  >
                                    <td width={'10%'} className='p-0' >
                                        <button className='btn btn-sm btn-link' onClick={(ev) => llamarPorTicket(ev, item.uidTicketFlujo)}>
                                            { item.codigoTipoAtencion.toUpperCase() }-{ item.numeroTicket }
                                        </button>
                                    </td>
                                    <td width={'35%'} className='p-0'> 
                                        {item.tipoAtencion.toUpperCase()}
                                    </td>

                                    <td width={'35%'} className='p-0'> 
                                        { item.nombrePaciente.trim() === '' ? item.numeroDocumento : item.nombrePaciente.toUpperCase()}
                                    </td>

                                    <td width={'20%'} className='p-0'> 
                                        { item.hora }
                                    </td>

                            
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>



        </div>
    )
}
